import { ScheduleEntryState, Timestamp } from '@griply/types';
import { isSameDay } from 'date-fns';

type ScheduleTask = {
  schedules: {
    endDate?: Timestamp | null;
    completionTarget: { count: number };
    entries: {
      date: Timestamp;
      state: ScheduleEntryState;
      value?: number | null;
    }[];
  }[];
};

// "Completed for the date" = today's occurrence reached its completion target —
// the same notion that moves a habit into Today's completed bucket. Distinct
// from `isHabitCompletedOnDay`, which is true on any progress (value > 0).
export const isScheduleTaskCompletedForDate = (
  task: ScheduleTask,
  date: Timestamp,
): boolean =>
  task.schedules.some(
    ({ endDate, entries, completionTarget }) =>
      !endDate &&
      entries.some(
        ({ date: entryDate, state, value }) =>
          isSameDay(entryDate, date) &&
          state === ScheduleEntryState.Complete &&
          (value ?? 0) >= completionTarget.count,
      ),
  );
